import ContentFilterValues from "../../model/ContentFilter";
import globalState from "../../globalState";
import { Role } from "myfitworld-model";
import { isFilterEmptyFunc } from "./helpers";
import { filterByKeys } from "./filterByField";
import { filterBySwitch } from "./filterBySwitch";
import { SwitchKeys } from "./keys";

const clientSideContentFilter = ({ list, filter, orgId, endpoint }:
  {
    list: any[],
    filter: ContentFilterValues,
    orgId?: string,
    endpoint?: string
  }
): any[] => {
  const { currentRole: userRole = Role.Trainer, currentUserId: userId = "", currentOrganization } = globalState.getRawState();

  let res = [...list];
  const searchBySelectField = !isFilterEmptyFunc(filter);

  // Switch filters:
  res = filterBySwitch({
    content: res,
    filter,
    organization: currentOrganization,
    userId: userId,
    userRole: userRole,
    endpoint: endpoint,
    platformId: orgId || "",
  })
  // Select filters:
  if (searchBySelectField) {
    const contentKeysOnly = Object.fromEntries(
      Object.entries(filter).filter(([key]) => !SwitchKeys.includes(key as any))
    );
    res = filterByKeys(res, {
      ...contentKeysOnly,
      difficultyLevel: Array.isArray(filter.difficultyLevel)
        ? filter.difficultyLevel.map(String)
        : filter.difficultyLevel?.toString(),
    });
  }

  return res;
};

export default clientSideContentFilter;